// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/atc-cannot-clear.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/atc-cannot-clear/atc-cannot-clear.js';

mount([g0]);
